import { useCallback } from 'react';

function useThrottle(callback, delay) {
  var throttledCallback = useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var throttle;

    if (throttle) {
      clearTimeout(throttle);
    }

    throttle = setTimeout(function () {
      callback.apply(void 0, args);
      throttle = void 0;
    }, delay);
  }, [callback, delay]);
  return throttledCallback;
}

export { useThrottle };